import ApiFilesRepository from "../Repositories/Files/ApiFilesRepository";

import type { BaseFilesRepository } from "../Repositories/Files/BaseFilesRepository.interface";

import ExperimentalFilesRepository from "../Repositories/Files/ExperimentalFilesRepository";

type FilesServiceType = "api" | "experimental";

class FilesService {
  private type: FilesServiceType = "api";

  private Repository!: BaseFilesRepository;

  constructor(type: FilesServiceType) {
    this.type = type;

    this.assignRepository();
  }

  private assignRepository() {
    switch (this.type) {
      case "api":
        this.Repository = new ApiFilesRepository();

        break;

      case "experimental":
        this.Repository = new ExperimentalFilesRepository();

        break;

      default:
        this.Repository = new ApiFilesRepository();
    }
  }

  async readFile(directory: string, fileName: string): Promise<Blob | null> {
    return await this.Repository.readFile(directory, fileName);
  }

  async uploadFile(
    directory: string,

    fileName: string,

    file: Blob,

    onProgress?: (progress: number) => void,
  ) {
    return await this.Repository.uploadFile(
      directory,

      fileName,

      file,

      onProgress,
    );
  }

  async createDirectory(directoryPath: string) {
    return await this.Repository.createDirectory(directoryPath);
  }
}

export default FilesService;
